import { useContext } from "react";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "@/App.context";


const getCustomizableColumns = (token) => {
  return async ({ service, id }) => {
    const setReporting = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/customizable-columns`,
      {
        method: "GET",
        headers: {
          // "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (!setReporting.ok) {
      const errorResponse = await setReporting.json();
      throw new Error(errorResponse.message);
    }
    const data = await setReporting.json();

    return data;
  };
};

export const UseGetCustomizableColumns = (req, deps = [], enabled = true) => {
  const appContext = useContext(AppContext);

  const query = useQuery({
    queryKey: ["getCustomizableColumns", req, ...deps],
    queryFn: () => getCustomizableColumns(appContext.idToken)(req),
    enabled,
  });

  return query;
};
